import type { RegistryEntry } from '../types';

// Segmind 系列
export const segmindConfigs: Record<string, RegistryEntry> = {
  // Segmind Relight: tool-driven UI, forward modelUi -> providerOptions (root-level keys)
  relight: {
    options: [],
    toProviderOptions: (ui) =>
      ({
        light_direction: typeof ui.light_direction === 'string' ? ui.light_direction : undefined,
        light_intensity: typeof ui.light_intensity === 'string' ? ui.light_intensity : undefined,
        light_temperature: typeof ui.light_temperature === 'string' ? ui.light_temperature : undefined,
        light_type: typeof ui.light_type === 'string' ? ui.light_type : undefined,
        source_image_url: typeof ui.source_image_url === 'string' ? ui.source_image_url : undefined,
      } as unknown as Record<string, Record<string, any>>),
  },
};
